import { useEffect, useState } from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import _ from "lodash";
import { isMobile } from "react-device-detect";

import Link from "next/link";
import { calcVaildPromoDateWithTimeZone } from "../../utils/app";

const CityPromoList = ({ promos, city }: any) => {
  const [fixedPromos, setFixedPromos] = useState([]);
  const [randomPromos, setRandomPromos] = useState([]);

  const renderPromo = (promo: any) => (
    <div key={promo.id} className={`promo-item promo-type-${promo.kind}`}>
      <Link legacyBehavior href="/promos/[id]" as={`/promos/${promo.id}`}>
        <a
          id={`promo_${promo.id}`}
          title={promo.title}
          target="_blank"
          rel={`noopener noreferrer ${promo.follow ? "" : "nofollow"}`}>
          <img
            src={promo.image_url}
            alt={promo.title}
            width="100%"
            height="100%"
          />
        </a>
      </Link>
    </div>
  );

  useEffect(() => {
    if (promos) {
      const promoValidator = (p: any) => {
        const today = new Date();
        const { startDate, endDate } = calcVaildPromoDateWithTimeZone(p);
        return p.kind === "city" && today > startDate && today < endDate;
      };

      const fixedPromos = promos.filter(
        (p: any) =>
          p.position === 0 && promoValidator(p) && p.city_id === city.id
      );
      setFixedPromos(fixedPromos);

      let randomPromos = promos.filter(
        (p: any) =>
          p.position !== 0 && promoValidator(p) && p.city_id === city.id
      );
      if (isMobile) {
        /* 没有置顶广告时，补充一个随机显示的广告 */
        randomPromos = _.sampleSize(
          randomPromos,
          fixedPromos.length === 0 ? 3 : 2
        );
      }
      setRandomPromos(randomPromos);
    }
  }, [promos]);

  return (
    <div>
      {fixedPromos.map(renderPromo)}
      {randomPromos.map(renderPromo)}
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  promos: state.app.promos,
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CityPromoList);
